

import React from "react";

function ClientsNum() {
  return (
    <section className="w-full  py-10 sm:py-14 md:py-16 lg:py-20 mt-16 sm:mt-24 md:mt-32 lg:mt-80">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 place-items-center">

          {/* Item 1 */}
          <div className="flex justify-center w-full">
            <dotlottie-wc
              // src="https://lottie.host/14477eca-d29e-4b70-9e28-befef51bca4e/SSIP2o9z3A.lottie"
              src="https://lottie.host/d3319690-6e37-4adf-96d1-d36bb66c4135/Pp7f6lwfpf.lottie"
              className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72"
              autoplay
              loop
            />
          </div>

          {/* Item 2 */}
          <div className="flex justify-center w-full">
            <dotlottie-wc
              src="https://lottie.host/ac944b4f-ee06-42e0-919b-86eae0e68ad7/Ezdni946dw.lottie"
              className="w-44 h-44 sm:w-52 sm:h-52 md:w-60 md:h-60 lg:w-64 lg:h-64"
              autoplay
              loop
            />
          </div>

          {/* Item 3 */}
          <div className="flex justify-center w-full">
            <dotlottie-wc
              src="https://lottie.host/8ea60328-f805-403e-b47a-67a75de245ec/aMB2oimJaY.lottie"
              className="w-52 h-52 sm:w-60 sm:h-60 md:w-68 md:h-68 lg:w-72 lg:h-72"
              autoplay
              loop
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default ClientsNum;
